import React from 'react';
import PropTypes from 'prop-types';

import { POWER_PAST_DUE_MESSAGE } from '../../../../constants/payments';

const FableticsPastDueMessage = ({ hasPastDueSubscription, className, testId }) => {
    if (!hasPastDueSubscription) {
        return null;
    }
    return <p className={className} data-testid={testId}>{POWER_PAST_DUE_MESSAGE}</p>;
};

FableticsPastDueMessage.propTypes = {
    hasPastDueSubscription: PropTypes.bool.isRequired,
    className: PropTypes.string,
    testId: PropTypes.string,
};

FableticsPastDueMessage.defaultProps = {
    className: null,
    testId: null,
};

export default FableticsPastDueMessage;
